import BasePage from 'src/components/layouts/BasePage'
import React from 'react'
import DocumentTitle from 'src/components/common/DocumentTitle'
import ContactList from './ContactList'

export interface PeopleListProps {}

function PeopleList(_: PeopleListProps) {
  return (
    <BasePage>
      <DocumentTitle title={'Contacts'} />

      <ContactList />
    </BasePage>
  )
}

export default PeopleList
